import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp,IonicModule,IonicErrorHandler } from 'ionic-angular';
import { smarTavolinux } from './app.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpModule } from '@angular/http';
import { HttpClient,HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { StatusBar } from '@ionic-native/status-bar';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SplashScreen } from '@ionic-native/splash-screen';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { AppVersion } from '@ionic-native/app-version';
import { FCM } from '@ionic-native/fcm';
import { provider } from '../providers/provider';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { Geolocation } from '@ionic-native/geolocation';
import { Globalization } from '@ionic-native/globalization';

import { AboutPage } from '../pages/about/about';
import { CartPage } from '../pages/cart/cart';
import { EditProductPage } from '../pages/editProduct/editProduct';
import { ConfirmPage } from '../pages/confirm/confirm';
import { MenuPage } from '../pages/menu/menu';
import { HomePage } from '../pages/home/home';
import { ProductsHorizontalPage } from '../pages/products/productsHorizontal/productsHorizontal';
import { ProductsNoImageListPage } from '../pages/products/productsNoImageList/productsNoImageList';
import { ProductsVerticalPage } from '../pages/products/productsVertical/productsVertical';
import { SlotsListPage } from '../pages/products/slotsList/slotsList';
import { productDetailPage } from '../pages/productDetail/productDetail';
import { Search } from '../pages/search/search';
import { Failure } from '../pages/failure/failure';
import { Success } from '../pages/success/success';
import { CustomerPage } from '../pages/account/customer/customer';
import { SelectShopPage } from '../pages/selectshop/selectshop';

import { AddressesPage } from '../pages/account/addresses/addresses';
import { AddAddressPage } from '../pages/account/addAddress/addAddress';
import { CustomerRegistrationPage } from '../pages/account/customerRegistration/customerRegistration';
import { CustomerEditPage } from '../pages/account/customerEdit/customerEdit';
import { CustomerCardPage } from '../pages/account/customercard/customercard';
import { ModalPrivacyPage } from '../pages/account/modalPrivacy/modalPrivacy';
import { CustomizerProvider } from '../providers/customizer/customizer';
import { RoomCustomerProvider } from '../providers/room-customer/room-customer';
import { CreditPaymentPage } from '../pages/credit-payment/credit-payment';

import { CardModule } from 'ngx-card/ngx-card';
import { Deeplinks } from '@ionic-native/deeplinks';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function CustomizerProviderFactory(provider: CustomizerProvider) {
  return () => provider.loadCustomization('');
}

@NgModule({
  declarations: [
    smarTavolinux,
    HomePage,
    AboutPage,
    CartPage,
    MenuPage,
    ProductsHorizontalPage,
    ProductsNoImageListPage,
    ProductsVerticalPage,
    SlotsListPage,
    productDetailPage,
    Search,
    ConfirmPage,
    EditProductPage,
    Failure,
    Success,
    CustomerPage,
    CustomerCardPage,
    SelectShopPage,
    AddressesPage,
    CustomerRegistrationPage,
    CustomerEditPage,
    AddAddressPage,
    ModalPrivacyPage,
    CreditPaymentPage,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    CardModule,
    IonicModule.forRoot(smarTavolinux, {
      menuType: 'overlay',
      backButtonText: 'Indietro',
      mode: 'ios'
    }),
    //IonicPageModule.forChild(TutorialPage),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    IonicStorageModule.forRoot({
      name: 'tapdb',
      driverOrder: ['indexeddb', 'sqlite', 'websql']
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    smarTavolinux,
    HomePage,
    AboutPage,
    CartPage,
    MenuPage,
    ProductsHorizontalPage,
    ProductsNoImageListPage,
    ProductsVerticalPage,
    SlotsListPage,
    productDetailPage,
    Search,
    ConfirmPage,
    EditProductPage,
    Failure,
    Success,
    CustomerPage,
    CustomerCardPage,
    SelectShopPage,
    AddressesPage,
    CustomerRegistrationPage,
    CustomerEditPage,
    AddAddressPage,
    ModalPrivacyPage,
    CreditPaymentPage,
  ],
  providers: [
    provider,
    StatusBar,
    InAppBrowser,
    SplashScreen,
    BarcodeScanner,
    AppVersion,
    FCM,
    LocalNotifications,
    Geolocation,
    Globalization,
    Deeplinks,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    CustomizerProvider,
    { provide: APP_INITIALIZER, useFactory: CustomizerProviderFactory, deps: [CustomizerProvider], multi: true },
    RoomCustomerProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts